import { render, staticRenderFns } from "./CartInfo.vue?vue&type=template&id=3b3bc1a7&scoped=true&"
import script from "./CartInfo.vue?vue&type=script&lang=js&"
export * from "./CartInfo.vue?vue&type=script&lang=js&"
import style0 from "./CartInfo.vue?vue&type=style&index=0&id=3b3bc1a7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3bc1a7",
  null
  
)

export default component.exports